import { useEffect, useState } from 'react';
import { msUntilNextUTCDay } from './game';

// HH:MM:SS until the next UTC day (best-practice §11.4 next-puzzle countdown).
export function useCountdown(): string {
  const [ms, setMs] = useState(msUntilNextUTCDay());
  useEffect(() => {
    const t = setInterval(() => setMs(msUntilNextUTCDay()), 1000);
    return () => clearInterval(t);
  }, []);
  const s = Math.max(0, Math.floor(ms / 1000));
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(Math.floor(s / 3600))}:${p(Math.floor((s % 3600) / 60))}:${p(s % 60)}`;
}
